module.exports = __webpack_public_path__ + "img/certificate.d4a087a8.png";